module.exports = __webpack_public_path__ + "static/media/truck.446cad74.svg";